import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileButton: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiButton_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiButtonRole',
      bindings: [
        {
          title: 'mobui_MobuiButton_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [FieldType.text],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
